import { IntroductionDetails } from '@platform/client/schemas';
import {
  OrganizationProfileLink,
  ProfileItem,
  ProfileItemLong,
  ProfileLinkExternal,
  ProfileSection,
  ProfileTabContainer,
  ProjectProfileLink,
  ProUserProfileLink,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { formatUserFirstLast } from '../../../util/TextHelpers';

export const DetailsTabContent = ({ introData }: { introData?: IntroductionDetails | null }) => {
  return (
    <ProfileTabContainer>
      <ProfileSection title='Intro Details'>
        <OrganizationProfileLink
          organizationId={introData?.organization.id}
          organizationName={introData?.organization.name}
        />
        <ProUserProfileLink
          userId={introData?.professional.id}
          firstname={introData?.professional.firstName}
          lastname={introData?.professional.lastName}
        />
        <ProjectProfileLink
          projectId={introData?.project?.id}
          projectName={introData?.project?.name}
        />
        <ProfileItem label='Cohort' value={introData?.cohort?.name} />
        <ProfileItem
          label='Representative'
          value={formatUserFirstLast(
            introData?.representative?.firstName,
            introData?.representative?.lastName,
          )}
        />
        <ProfileItem label='Match Status' value={introData?.myProjectsStatus} />
        <ProfileItem label='Sent by' value={introData?.initiationType} />
        <ProfileItem
          label='Status Date'
          value={
            introData?.myProjectsStatusDate ?
              formatDateStr(introData?.myProjectsStatusDate)
            : undefined
          }
        />
        <ProfileItem
          label='Sent'
          value={introData?.createdAt ? formatDateStr(introData.createdAt) : undefined}
        />
        <ProfileLinkExternal label='Planning guide' href={introData?.planningGuideUrl} />
        <ProfileItem label='Outcome' value={introData?.outcome} />
      </ProfileSection>
      <ProfileSection title='Message' columns={1}>
        <ProfileItemLong label='Intro text' value={introData?.message} />
      </ProfileSection>
      <ProfileSection title='Discovery'>
        <ProfileItem
          label='Org Decision'
          value={
            introData?.discovery?.organizationDecision !== 'unresponsive' ?
              introData?.discovery?.organizationDecision
            : 'Pro is unresponsive'
          }
        />
        <ProfileItem
          label='Pro Decision'
          value={
            introData?.discovery?.professionalDecision !== 'unresponsive' ?
              introData?.discovery?.professionalDecision
            : 'Org is unresponsive'
          }
        />
        <ProfileItem label='Org Reason' value={introData?.discovery?.organizationReason} />
        <ProfileItem label='Pro Reason' value={introData?.discovery?.professionalReason} />
        <ProfileItem
          label='Call date'
          value={
            introData?.discovery?.callDate ? formatDateStr(introData.discovery.callDate) : undefined
          }
        />
      </ProfileSection>
      {/* {planData && <ProjectPlanSection planData={planData} />} */}
    </ProfileTabContainer>
  );
};
